import { render, staticRenderFns } from "./DetailFormSection.vue?vue&type=template&id=e882ff60&scoped=true"
import script from "./DetailFormSection.vue?vue&type=script&lang=js"
export * from "./DetailFormSection.vue?vue&type=script&lang=js"
import style0 from "./DetailFormSection.vue?vue&type=style&index=0&id=e882ff60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e882ff60",
  null
  
)

export default component.exports